import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function SelectEmailTemplate({ showModal, applyTemplate }) {
  const dispatch = useDispatch();

  /*   ALL STATES
   ********************************************* */
  const [emailTemplates, setEmailTemplates] = useState(null);

  /*   All Functions
   ********************************************* */
  const getEmailTemplates = useCallback(async () => {
    try {
      const { data } = await API.get("/emailformat", {
        headers: authHeader(),
      });

      if (data?.type === "success" || data?.success) {
        setEmailTemplates(data?.data || []);
        return;
      }

      dispatch(
        setNotification({
          message: data?.message || "Failed to load templates.",
          type: "error",
        }),
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err?.response?.data?.message || err?.message,
          type: "error",
        }),
      );
    }
  }, [dispatch]);

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      getEmailTemplates();
    }, 50);
    return () => clearTimeout(timeout);
  }, [getEmailTemplates]);

  /*   Table functions
   ********************************************* */
  const table_head = ["Name", "Action"];

  const table_body = (item) => (
    <tr className="" key={item.id}>
      <td>{item.title}</td>
      <td>
        <button
          onClick={() => {
            applyTemplate(item);
            showModal(false);
          }}
          className="btn btn-success btn-sm"
        >
          Select
        </button>
      </td>
    </tr>
  );

  return (
    <div>
      {/*   Table
       ********************************************* */}
      <div className="px-2 flex-grow-1 d-flex">
        <div className="horizontal-scrollable d-flex flex-grow-1">
          {emailTemplates ? (
            <Table
              table_head={table_head}
              table_body={table_body}
              table_data={emailTemplates}
            />
          ) : (
            <Spinner />
          )}
        </div>
      </div>
      <div className="text-end my-2">
        <button
          onClick={() => {
            showModal(false);
          }}
          className="btn btn-secondary"
        >
          Close
        </button>
      </div>
    </div>
  );
}
